import React from "react"
import Cross from "assets/svgs/Cross"
import ProgressMeetViewModel from "../ProgressMeetViewModel"
import useLocalStorage from "core/hooks/useLocalStorage"
import { ProgressMeetFeedback } from "domain/model/ProgressMeet"
import StandardSelect from "core/components/v2/StandardSelect"
interface ProgressMeetFeedbackModalProps {
  isOpen: boolean | null
  setIsOpen: (isOpen: boolean) => void
  chapterName: string
  meetingId: string
  saveFeedback: (feedback: ProgressMeetFeedback) => void
}
export default function ProgressMeetFeedbackModal({
  isOpen,
  setIsOpen,
  chapterName,
  saveFeedback,
  meetingId,
}: ProgressMeetFeedbackModalProps) {
  if (!isOpen) return null
  const feedbackSections = [
    {
      title: "Live Classes Feedback :",
      description: "(Scale: 1 - Poor to 10 - Excellent)",
      key: "live_classes_feedback",
    },
    {
      title: "Mentorship Session Feedback : ",
      description: "(Scale: 1 - Poor to 10 - Excellent)",
      key: "mentorship_session_feedback",
    },
    {
      title: "Exams and Milestone Exams Feedback :",
      description: "(Scale: 1 - Poor to 10 - Excellent)",
      key: "exams_feedback",
    },
    {
      title: "Content Quality Feedback (Notes and Assignments) :",
      description: "(Scale: 1 - Poor to 10 - Excellent)",
      key: "content_quality_feedback",
    },
    {
      title: "Doubt Support Feedback (Problem-Solving Doubts) :",
      description: "(Scale: 1 - Poor to 10 - Excellent)",
      key: "doubt_support_feedback",
    },
  ]

  const [nextClicked, setNextClicked] = React.useState(false)
  const [student, setStudent] = useLocalStorage<any>("student", {})
  const [suggestions, setSuggestions] = React.useState("")

  const [ratings, setRatings] = React.useState({
    live_classes_feedback: 0,
    mentorship_session_feedback: 0,
    exams_feedback: 0,
    content_quality_feedback: 0,
    doubt_support_feedback: 0,
    recommendation_score: 0,
  })

  const [selectedRatings, setSelectedRatings] = React.useState<{ [key: string]: number }>({})
  const [isNextDisabled, setIsNextDisabled] = React.useState(true)
  const [isSubmitDisabled, setIsSubmitDisabled] = React.useState(true)
  const [selectedValue, setSelectedValue] = React.useState<string>("")

  React.useEffect(() => {
    const allSelected = feedbackSections.every((section) => selectedRatings[section.key] > 0)
    setIsNextDisabled(!allSelected)
  }, [selectedRatings])

  React.useEffect(() => {
    setIsSubmitDisabled(!selectedRatings.recommendation_score)
  }, [selectedRatings.recommendation_score])

  const handleNextClick = () => {
    setNextClicked(true)
  }
  const handlePreviousClick = () => {
    setNextClicked(false)
  }
  const handleRatingChange = (key: string, value: number) => {
    setSelectedRatings((prevRatings) => ({
      ...prevRatings,
      [key]: value,
    }))
  }

  const handleSubmitClick = () => {
    const feedbackData: ProgressMeetFeedback = {
      name: student.name || "",
      email: student.email || "",
      batch: student.batch || "",
      meeting_id: meetingId || "",
      chapter_name: chapterName || "",
      live_classes_feedback: selectedRatings.live_classes_feedback,
      mentorship_session_feedback: selectedRatings.mentorship_session_feedback,
      exams_feedback: selectedRatings.exams_feedback,
      content_quality_feedback: selectedRatings.content_quality_feedback,
      doubt_support_feedback: selectedRatings.doubt_support_feedback,
      recommendation_score: selectedRatings.recommendation_score,
      suggestions: suggestions,
      timestamp: Date.now(),
    }

    saveFeedback(feedbackData)

    setIsOpen(false)
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0  bg-[rgba(12,12,12,0.9)] z-0"></div>
      <div className="w-[525px] h-[720px] p-6   relative bg-white rounded-lg shadow-lg z-10  ">
        <div className="flex justify-between  mb-3">
          <div>
            <h4
              className="text-[#333]
           font-inter text-[16px] font-semibold leading-normal"
            >
              Progress Meeting Feedback{" "}
            </h4>
            <p
              className="text-[var(--Black-and-white-Gray-500,#646464)] 
           font-inter text-[14px] font-medium leading-normal"
            >
              Provide your valuable feedback to increase meeting quality.{" "}
            </p>
          </div>

          <button className="hover:bg-[#D3D3D3] duration-500 rounded-sm h-[24px]" onClick={() => setIsOpen(false)}>
            <Cross />
          </button>
        </div>
        <div className="flex justify-between p-[12px_16px] items-start gap-[20px] self-stretch rounded-[8px] bg-[#F9F9F9]">
          <div className="text-[#333] font-inter text-[14px] font-semibold leading-normal mt-[4px]">
            User Email ID<span className="text-[#DC2626] font-inter text-[14px] font-semibold leading-normal">*</span>
          </div>
          <div className="rounded-[4px] border-[1px] border-[#D3D3D3] bg-white flex w-[300px] h-[33px] py-[8px] px-[16px] items-center overflow-hidden whitespace-nowrap text-ellipsis ">
            <p className="text-[#646464] font-inter text-[14px] font-normal leading-normal">{student.email}</p>
          </div>
        </div>
        {!nextClicked ? (
          <div className="flex flex-col gap-2">
            {feedbackSections.map((section, idx) => {
              return (
                <div key={idx} className="mt-4">
                  <p className="text-[#333] font-inter text-[14px] font-semibold leading-normal mt-[4px]">
                    {section.title}
                  </p>
                  <p className="text-[#646464] font-inter text-[14px] font-normal leading-normal h-[17px]">
                    {section.description}
                    <span className="text-[#DC2626] font-inter text-[14px] font-semibold leading-normal">*</span>
                  </p>
                  <div className="flex gap-1 mt-2">
                    {Array.from({ length: 10 }).map((_, index) => (
                      <div
                        key={index}
                        onClick={() => handleRatingChange(section.key, index + 1)}
                        className={`flex w-[44px] h-[29px] p-[6px_11px] justify-center items-center flex-shrink-0 rounded-[6px] 
                           bg-[#F9F9F9] font-semibold text-[#333]
        ${selectedRatings[section.key] == index + 1 ? "!bg-[#88CC30]" : ""} 
        hover:bg-[#88CC30] active: cursor-pointer`}
                      >
                        {index + 1}
                      </div>
                    ))}
                  </div>
                </div>
              )
            })}
          </div>
        ) : (
          <div>
            <div className="flex justify-between w-full gap-2">
              <div className="w-[292px] h-[85px] mt-6">
                <p className="text-[#333] font-inter text-[14px] font-semibold leading-normal">Recommendation Score:</p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-normal">
                  {" "}
                  On a scale of 1 to 10, how likely are you to recommend the Bosscoder Academy program to your friends
                  and colleagues? (1 - Not Likely to 10 - Highly Likely)
                  <span className="text-[#DC2626] font-inter text-[14px] font-semibold leading-normal">*</span>
                </p>
              </div>
              <div className="relative w-[146px] h-[35px] mt-6">
                <StandardSelect
                  dimensions="w-[146px]"
                  className="rounded-md border border-[#d3d3d3]"
                  placeholder={selectedValue || "1-10"}
                  name="recommendation_score"
                  value={selectedValue}
                  onChange={(value: string) => {
                    setSelectedValue(value) // Update state
                    handleRatingChange("recommendation_score", parseInt(value))
                  }}
                  options={Array.from({ length: 10 }, (_, index) => (index + 1).toString())}
                  required
                />
              </div>
            </div>
            <p className="text-[#333] font-inter text-[14px] font-semibold leading-normal mt-8">
              Suggestions or Feedback
            </p>
            <p className="text-[#646464] font-inter text-[14px] font-normal leading-normal mt-1">
              Do you have any suggestions, concerns, or additional feedback to help improve your experience?
            </p>
            <textarea
              onChange={(e) => setSuggestions(e.target.value)}
              className=" mt-4 w-[475.4px] h-[223px] gray-scrollbar overflow-y-auto p-3 border border-[#D3D3D3] rounded-[4px] resize-none focus:outline-none focus:ring-1 focus:ring-[#1C3474]"
              placeholder="Type your message here!"
            ></textarea>
          </div>
        )}
        {!nextClicked ? (
          <div className="absolute bottom-0 left-0 w-full bg-[#F9F9F9] pt-3 pr-4 flex justify-end rounded-b-[8px] h-[59px]">
            <button
              className={`inline-flex w-[64px] h-[35px] p-[9px_16px] justify-center items-center gap-[10px] rounded-[4px] 
               ${isNextDisabled ? "bg-gray-300 cursor-not-allowed" : "bg-[#162456] hover:bg-[#1C3474] active:bg-[#333] text-white"} 
               font-inter text-[14px] font-medium leading-normal`}
              onClick={handleNextClick}
              disabled={isNextDisabled}
            >
              Next
            </button>
          </div>
        ) : (
          <div className="absolute bottom-0 left-0 w-full bg-[#F9F9F9] pt-3 pr-4  flex justify-end gap-2 rounded-b-[8px] h-[59px]">
            <button
              className="inline-flex w-[90px] h-[35px] p-[9px_16px] justify-center items-center gap-[13px] rounded-[4px] border-[1px] border-[#D3D3D3] bg-[#FFF] hover:border-[#FFF] hover:bg-[#F5F5F5] active:border-[#FFF] active:bg-[#1C3474] active:text-white text-[#646464)] font-inter text-[14px] font-medium leading-normal"
              onClick={handlePreviousClick}
            >
              Previous
            </button>
            <button
              className={`inline-flex w-[149px] h-[35px] p-[9px_16px] justify-center items-center gap-[10px] rounded-[4px] 
              ${isSubmitDisabled ? "bg-gray-300 cursor-not-allowed" : "bg-[#162456] hover:bg-[#1C3474] active:bg-[#333] text-white"} 
              font-inter text-[14px] font-medium leading-normal`}
              onClick={handleSubmitClick}
              disabled={isSubmitDisabled}
            >
              Submit Feedback
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
